import { $, $$, sleep } from '../_utils'

const PRODUCT_CARD_ACTIVE_CLASS = 'active'
const PRODUCT_CARD_CLOSE_ALL_DELAY = 100
const PRODUCT_CARD_DETAILS_SELECTOR = '.js-product-card-details'
const PRODUCT_CARD_SELECTOR = '.js-product-card'
const PRODUCT_CARD_TRIGGER_SELECTOR = '.js-product-card-trigger'
const PRODUCT_CARD_CLOSE_SELECTOR = '.js-product-card-close'
const TRAINING_LINK_SELECTOR = '.js-product-card__anchor-link'

class ProductCard {
  static addClickListeners = struct => {
    const { $productCardTrigger, $productCardClose } = struct

    $productCardTrigger?.addEventListener('click', event => {
      this.handleTriggerClick(event, struct)
    })

    $productCardClose?.addEventListener('click', () => {
      this.closeProductCard(struct)
    })
  }

  static closeProductCards = struct => {
    const { $$otherProductCards } = struct

    $$otherProductCards.forEach($productCard => {
      $productCard.classList.remove(PRODUCT_CARD_ACTIVE_CLASS)
    })
  }

  static closeProductCard = struct => {
    const { $productCard } = struct
    $productCard.classList.remove(PRODUCT_CARD_ACTIVE_CLASS)
  }

  static getTraininglink = struct => {
    const { $productCardLink } = struct
    return $productCardLink.getAttribute('href')
  }

  static openTraining = struct => {
    window.location.href = this.getTraininglink(struct)
  }

  static handleTriggerClick = async (event, struct) => {
    event.preventDefault()
    const { $productCard } = struct
    if ($productCard.className.includes(PRODUCT_CARD_ACTIVE_CLASS)) this.openTraining(struct)
    this.closeProductCards(struct)
    await sleep(PRODUCT_CARD_CLOSE_ALL_DELAY)
    $productCard.classList.add(PRODUCT_CARD_ACTIVE_CLASS)
  }

  static init = ($$otherProductCards, $productCard) => {
    const struct = {
      $$otherProductCards,
      $productCard,
      $productCardDetails: $(PRODUCT_CARD_DETAILS_SELECTOR, $productCard),
      $productCardTrigger: $(PRODUCT_CARD_TRIGGER_SELECTOR, $productCard),
      $productCardClose: $(PRODUCT_CARD_CLOSE_SELECTOR, $productCard),
      $productCardLink: $(TRAINING_LINK_SELECTOR, $productCard),
    }
    struct |> this.addClickListeners
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const $$productCards = $$(PRODUCT_CARD_SELECTOR)

  $$productCards.forEach(($productCard, index) => {
    const $$otherProductCards = $$productCards.filter((_, otherIndex) => otherIndex !== index)

    ProductCard.init($$otherProductCards, $productCard)
  })
})
